import type { ReactNode } from 'react'

import { Box, type BoxProps, Grid, Text } from '@enechain/ecloud-designsystem'

/**
 * 契約・契約者モーダルの「ラベル左 / 入力右」の 2 カラム (モック `FormGrid` と同じ)。
 * ラベルと入力を別セルに置くので、 `FieldRoot` ではなく plain label を使う
 * (`AdminSingularDay/components/SingularDayForm` と同じ構成)。
 */
export const FormGrid = ({
  children,
}: {
  children: ReactNode
}): React.ReactElement => (
  <Grid
    alignItems="center"
    gridRowGap={3}
    gridColumnGap={4}
    gridTemplateColumns="max-content 1fr"
  >
    {children}
  </Grid>
)

const BoxAsLabel = Box as unknown as React.FC<
  Omit<BoxProps, 'as'> & {
    as?: string
    htmlFor?: string
    children?: React.ReactNode
  }
>

export const GridLabel = ({
  htmlFor,
  children,
}: {
  htmlFor?: string
  children: ReactNode
}): React.ReactElement => (
  <BoxAsLabel
    as="label"
    textStyle="label"
    color="Text.highEmphasis"
    htmlFor={htmlFor}
  >
    {children}
  </BoxAsLabel>
)

/** 変えられない項目の表示 (入力欄を無効にせず文で出す)。 */
export const ReadOnlyRow = ({
  label,
  children,
}: {
  label: string
  children: ReactNode
}): React.ReactElement => (
  <>
    <GridLabel>{label}</GridLabel>
    <Text as="div" color="Text.highEmphasis" fontSize="md">
      {children}
    </Text>
  </>
)
